import React, {Component} from 'react'
import { numberWithCommas } from '../../fiches';
import CommonFetch from '../../requests/commonFetch'

export default class History extends Component {
    constructor(props) {
        super(props)

        this.direction = {
            output: '-',
            input: '+',
        }
        const historyList = [
            {
                address: "",
                amount: "",
                blockchain: "",
                currency: "",
                direction: "",
                timestamp: 0,
                txid: "",
            },
        ];

        this.state = {
            historyList: historyList,
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        CommonFetch({
            path: 'ui/history/get_data',
            method: 'GET',
        }).then(data => {
            if (data.success) {
                this.setState({
                    historyList: data.transactions,
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }


    convertDate = (timestamp) => {
        return new Date(timestamp*1000);
    }

    render(){
        return (
            <div className="history">
                <div className="header_block">
                    <div>
                        <h2>{this.translation['History']}</h2>
                        <hr/>
                    </div>
                    <div>

                    </div>
                    <div>

                    </div>
                </div>
                <div className="history_block">
                    <div className="table table-history">
                        {
                            this.state.historyList.map((listItem, index) => {
                                let date = this.convertDate(listItem.timestamp);
                                return (
                                    <div className="table_row" key={index}>
                                        <div className="transaction-date">{date.getDate() < 10 ? '0'+date.getDate() : date.getDate()}.{date.getMonth() < 9 ? '0'+(date.getMonth()+1) : date.getMonth()+1}.{date.getFullYear()%100}</div>
                                        <div className="transaction-time">{date.getHours() == 0 ? '00' : date.getHours() < 10 ? '0'+date.getHours() : date.getHours()}:{date.getMinutes() == 0 ? '00' : date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()}</div>
                                        <div className={`transfer ${listItem.blockchain === 'DEPO' ? 'lowercase' : ''}`}>{this.direction[listItem.direction]} {numberWithCommas(listItem.amount)} {listItem.currency}</div>
                                        <div className="description">{listItem.address}</div>
                                    </div>
                                )
                            })
                        }
                        {/*<a href="/" className="btn">Load more transactions</a>*/}
                    </div>
                </div>
            </div>
        )
    }
}
